import React from 'react';
import EmailField from './EmailField';
import Notes from './Notes';

export default class Schedule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            saveButtonText: 'Save Schedule',
            readOnly: false
        };
    }

    sortBy = (sortType) => {
        const sortDir = sortType !== this.props.sortType ? 'asc' : (this.props.sortDirection === 'asc' ? 'desc' : 'asc');

        return () => {
            this.props.actions.sortSchedule(sortType, sortDir);
        }
    }

    removeAll = () => {
        if (confirm('Are you sure you want to delete all teachers from this schedule? This cannot be undone.')) {
            this.props.actions.deleteAll();
        }
    }

    setFocus = (id, updates, focusRef) => {
        const el = this.refs[`row_${id}`];

        if (el) {
            const row = el.refs.row;
            if (row) {
                row.setUpdatesAndFocus(updates, focusRef);
            }
        }
    }

    getClassName = (field) => {
        if (this.props.sortType !== field) {
            return 'toporbottom';
        }

        if (this.props.sortDirection === 'asc') {
            return 'toporbottom top';
        }

        return 'toporbottom bottom';
    }

    save = () => {
        this.setState({ saveButtonText: 'Saving...', readOnly: true }, () => {
            setTimeout(() => {
                window.location = window.location.href;
            }, 2000);
        });
    }

    render() {
        const extraRowCount = Math.max(1, 15 - this.props.scheduleOrder.length);
        const extraRows = [];

        for (let i = 0; i < extraRowCount; i++) {
            extraRows.push(
                <CreateScheduleRow
                    key={ `0.${i}` }
                    index={ this.props.scheduleOrder.length + 1 + i }
                    eventDates={ this.props.eventDates }
                    schedule={ {} }
                    readOnly={ this.state.readOnly }
                    structures={ this.props.structures }
                    domains={ this.props.domains }
                    setFocus={ this.setFocus }
                    actions={ this.props.actions } />
            );
        }

        return (
            <div>
                <div id="scheduleBlock">
                    <table id="scheduleTable">
                        <thead>
                            <tr>
                                <td
                                    width="22px"
                                    className={ this.getClassName('id') }
                                    onClick={ this.sortBy('id') }>
                                </td>
                                <td
                                    style={ { width: '90px', overflow: 'hidden' } }
                                    className={ this.getClassName('first_name') }
                                    onClick={ this.sortBy('first_name') }>
                                    Teacher First Name
                                </td>
                                <td
                                    style={ { width: '100px', overflow: 'hidden' } }
                                    className={ this.getClassName('last_name') }
                                    onClick={ this.sortBy('last_name') }>
                                    Last Name
                                </td>
                                <td
                                    className={ this.getClassName('email_address') }
                                    onClick={ this.sortBy('email_address') }>
                                    E-Mail
                                </td>
                                <td style={ { width: '90px', overflow: 'hidden' } }>
                                    Structure
                                </td>
                                { this.props.eventDates.length > 1 ? 
                                    <td
                                        style={ { width: '60px', overflow: 'hidden' } }
                                        className={ this.getClassName('coaching_timestamp') }
                                        onClick={ this.sortBy('coaching_timestamp') }>
                                        Date
                                    </td>
                                    : null
                                }
                                <td
                                    style={ { width: '50px', overflow: 'hidden' } }
                                    className={ this.getClassName('coaching_timestamp') }
                                    onClick={ this.sortBy('coaching_timestamp') }>
                                    Start<br />Time
                                </td>
                                <td style={ { width: '50px', overflow: 'hidden' } }>
                                    Room
                                </td>
                                <td style={ { width: '50px', overflow: 'hidden' } }>
                                    Grade
                                </td>
                                <td style={ { width: '70px', overflow: 'hidden' } }>
                                    Subject
                                </td>
                                <td style={ { width: '70px', overflow: 'hidden' } }>
                                    Building
                                </td>
                                <td style={ { width: '50px', overflow: 'hidden' } }>
                                    { !this.state.readOnly ? <a className="removeRow" onClick={ this.removeAll }>Remove<br />All</a> : null }
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.scheduleOrder.map((id, index) => (
                                    <UpdateScheduleRow
                                        key={ id }
                                        ref={ `row_${id}` }
                                        index={ index + 1 }
                                        readOnly={ this.state.readOnly }
                                        eventDates={ this.props.eventDates }
                                        schedule={ this.props.schedule[id] }
                                        structures={ this.props.structures }
                                        domains={ this.props.domains }
                                        actions={ this.props.actions } />
                                ))
                            }
                            { extraRows }
                        </tbody>
                    </table>
                </div>
                <table style={ { width: '100%', marginTop: '1em' } }>
                    <tbody>
                        <tr>
                            <td vAlign="top" style={ { width: '50%' } }>
                                <em>
                                    Please enter a scheduled time for staff debrief at the end of the day.
                                </em>
                            </td>
                            <td vAlign="top" rowSpan="2" style={ { textAlign: 'right' } }>
                                <button className="floaterButton nolimit" type="button" onClick={ this.save }>{ this.state.saveButtonText }</button>
                                <br />
                                <button className="floaterButton nolimit" type="button" onClick={ window.print }>Print Schedule</button>
                            </td>
                        </tr>
                        <tr>
                            <td vAlign="top">
                                <Notes { ...this.props } />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

class CreateScheduleRow extends React.Component {
    constructor(props) {
        super(props);

        this.getDefaultState = () => ({
            creating: false,
            updates: { email_address: '' },
            updateOrder: []
        });

        this.state = this.getDefaultState();
    }

    transferTo = (id) => {
        this.props.setFocus(id, this.state.updates, this.state.updateOrder[this.state.updateOrder.length - 1]);
        this.setState(this.getDefaultState());
    }

    update = (field, value) => {
        const { updates, updateOrder } = this.state;

        updates[field] = value;

        if (updateOrder.indexOf(field) < 0) {
            updateOrder.push(field);
        }

        this.setState({ updates, updateOrder });

        if (!this.state.creating) {
            this.setState({ creating: true }, () => {
                this.props.actions.createRow(id => {
                    this.transferTo(id);
                });
            });
        }

        return;
    }

    render() {
        return (
            <ScheduleRow
                { ...this.props }
                ref="row"
                emailIgnoreDomain
                schedule={ this.state.updates }
                update={ this.update } />
        );
    }
}

class UpdateScheduleRow extends React.Component {
    update = (field, value) => {
        this.props.actions.saveCell({
            id: this.props.schedule.id,
            field,
            value
        });
    }

    massUpdate = (fields) => {
        this.props.actions.saveCells({ id: this.props.schedule.id, fields });
    }

    render() {
        return (
            <ScheduleRow
                ref="row"
                { ...this.props }
                massUpdate={ this.massUpdate }
                update={ this.update } />
        );
    }
}

class ScheduleRow extends React.Component {
    setUpdatesAndFocus = (updates, focusRef) => {
        if (this.props.massUpdate) {
            this.props.massUpdate(updates);
        }

        if (this.refs[focusRef]) {
            this.refs[focusRef].focus();
        }
    }

    inputize = (field) => {
        return (
            <input
                type="text"
                className="cellLike"
                ref={ field }
                disabled={ this.props.readOnly }
                value={ this.props.schedule[field] || '' }
                onFocus={ this.setFocus }
                onChange={ (e) => this.props.update(field, e.target.value) } />
        );
    }

    getDateCol = () => {
        if (this.props.eventDates.length < 2) {
            return null;
        }

        return (
            <td>
                <select
                    className="cellLike"
                    value={ this.props.schedule.coaching_date }
                    disabled={ this.props.readOnly }
                    onChange={ (e) => this.props.update('coaching_date', e.target.value) }>
                    <option value=""></option>
                    { this.props.eventDates.map(ed => <option key={ ed } value={ ed }>{ ed }</option>) }
                </select>
            </td>
        );
    }

    getStructureCol = () => {
        return (
            <td>
                <select
                    className="cellLike"
                    value={ this.props.schedule.structure_id }
                    disabled={ this.props.readOnly }
                    onChange={ (e) => this.props.update('structure_id', e.target.value) }>
                    <option key={ 0 } value='0'></option>
                    {
                        this.props.structures.map(structure => (
                            <option key={ structure.id } value={ structure.id }>{ structure.name }</option>
                        ))
                    }
                </select>
            </td>
        );
    }

    render() {
        const { schedule, index } = this.props;

        if (!schedule) {
            return null;
        }

        return (
            <tr key={ schedule.id }>
                <td className="row-count">{ index }</td>
                <td>{ this.inputize('first_name') }</td>
                <td>{ this.inputize('last_name') }</td>
                <td>
                    <EmailField
                        ref='email_address'
                        { ...this.props }
                        value={ this.props.schedule.email_address } />
                </td>
                { this.getStructureCol() }
                { this.getDateCol() }
                <td>{ this.inputize('coaching_time') }</td>
                <td>{ this.inputize('room_number') }</td>
                <td>{ this.inputize('grade_level') }</td>
                <td>{ this.inputize('subject') }</td>
                <td>{ this.inputize('topic') }</td>
                <td style={ { textAlign: 'center' } }>
                    { schedule.id && !this.props.readOnly
                        ? <a className="removeRow" onClick={ () => this.props.actions.deleteRow(schedule.id) }>Remove</a>
                        : null
                    }
                </td>
            </tr>
        );
    }
}
